import { Controller } from "@hotwired/stimulus"
import { Offcanvas } from "bootstrap"

export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    if (!this.hasDialogTarget) return

    this._offcanvas = Offcanvas.getOrCreateInstance(this.dialogTarget)
    this._offcanvas.show()

    // Clear the turbo frame after the offcanvas finishes hiding so the next
    // trigger can open a fresh one
    this._onHidden = () => {
      const frame = this.element.closest("turbo-frame")
      if (frame) frame.innerHTML = ""
    }
    this.dialogTarget.addEventListener("hidden.bs.offcanvas", this._onHidden)
  }

  disconnect() {
    if (!this.hasDialogTarget) return

    this.dialogTarget.removeEventListener("hidden.bs.offcanvas", this._onHidden)
    this._offcanvas?.hide()
    this._offcanvas?.dispose()
  }
}
